import { MathJax } from "better-react-mathjax";

interface Props {
    children: string;
};

const Mfi = ({ children }: Props):JSX.Element  =>  {
    return <span className="math" ><MathJax inline={true}>{children}</MathJax></span>;
};
export default Mfi;